import { Consequence } from '@innovatm/js-rule-editor';
import { Alert } from '@mui/material';
import Box from '@mui/material/Box';
import { useFormikContext } from 'formik';
import React, { memo, useEffect } from 'react';

import { ResourceManagerRule, RuleConsequenceCreateObject } from '../../../backend';
import { useBoolean } from '../../../hooks/useBoolean';
import { CreateResourceScore } from './CreateResourceScore';
import { DefaultConsequence } from './DefaultConsequence';

export const ConsequenceBox = memo(function ConsequenceBox() {
    const { initialValues, values } = useFormikContext<ResourceManagerRule>();
    const { value: defaultConsequence, toggle, setTrue } = useBoolean(false);

    useEffect(() => {
        if (
            initialValues.consequence?.type === 'RuleConsequenceCreateObject' &&
            (initialValues.consequence as RuleConsequenceCreateObject)?.objectType === 'ResourceScore' &&
            (initialValues.consequence as RuleConsequenceCreateObject)?.objectFields !== null
        ) {
            setTrue();
        }
    }, [setTrue, initialValues]);

    if (!values.conditions?.conditionOnObjects?.[0]?.objectType) {
        return <Alert severity="warning">You must select an object type to create a consequence.</Alert>;
    }

    return (
        <>
            {values.conditions?.conditionOnObjects?.[0]?.objectType && (
                <Box display={'flex'} justifyContent={'end'}>
                    <CreateResourceScore defaultConsequence={defaultConsequence} toggle={toggle} />
                </Box>
            )}
            {defaultConsequence ? <DefaultConsequence /> : <Consequence />}
        </>
    );
});
